const spaces = {
    none: "none",
    xxxs: "xxxs",
    xxs: "xxs",
    xs: "xs",
    sm: "sm",
    md: "md",
    lg: "lg",
    xl: "xl",
    xxl: "xxl",
};
export default Object.freeze(spaces);
